import moment from 'moment'
import * as _ from 'lodash'
import { getPanic } from '../api/storyblok';

const setPanic = async () => {
    const panic = await getPanic()
    if (panic) {
        console.log('Updating the pcs data/time')
        localStorage.setItem('pcs_update', moment().toISOString())
        localStorage.setItem('pcs_data', JSON.stringify(panic.content))
        return panic.content
    }
    return undefined
}

export const getPanicData = async (fromCache = true) => {
    if (!fromCache) {
        const panic = await setPanic()
        return panic
    }
    
    const json = localStorage.getItem('pcs_data')
    const lastUpdate = localStorage.getItem('pcs_update')
    let data = json ? JSON.parse(json) : null

    if (!lastUpdate || (lastUpdate && moment(lastUpdate).diff(moment(), 'minutes') > 5)) {
        await setPanic()
    } else {
        console.log('Loading the pcs from local storage')
    }
    return data
}

const getPanicItem = async (property: any) => {
    const data = await getPanicData()
    return _.get(data, property) || null
}

export default {
    getPanicItem,
    getPanicData,
}